<template>
  <v-snackbar v-model="show" bottom left :color="status" :timeout="timeout" height="44">
    <div class="max-width d-flex align-center">
      <v-icon small class="px-4" color="white"> {{ statusIcon }}</v-icon>
      <span class="snackmessage">{{ message }}</span>
      <v-spacer />
      <v-btn icon color="white" class="" text @click="show = false">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: 'loading',
  props: {},
  components: {},
  data() {
    return {
      show: false,
      message: '',
      status: 'error',
      timeout: 5000,
      statusIcon: ''
    }
  },
  created() {
    this.$store.watch(
      state => state.general.snackmsg,
      () => {
        const msg = this.$store.state.general.snackmsg
        if (msg !== '') {
          this.message = this.$store.state.general.snackmsg
          this.status = this.$store.state.general.snackstatus
          this.show = true
          const data = {
            msg: '',
            status: ''
          }
          this.$store.commit('general/SET_SNACKBAR', data)
        }
      }
    )
  },
  watch: {
    show() {
      if (this.show) {
        switch (this.status) {
          case 'success':
            this.statusIcon = 'mdi-check-circle-outline'
            break
          case 'error':
            this.statusIcon = 'mdi-alert-circle-outline'
            break
          case 'warning':
            this.statusIcon = 'mdi-sync'
            break
          default:
            break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
